import type { ImportantDisclosuresModuleProps } from "./renderProps";
import { useDisclosureFootnotes } from "./disclosureFootnotes";
import { renderTextWithLineBreaks } from "./text";

export function ImportantDisclosuresModule({
  heading,
  paragraphs,
}: ImportantDisclosuresModuleProps) {
  const disclosureFootnotes = useDisclosureFootnotes();
  const visibleParagraphs = paragraphs.filter((paragraph) =>
    paragraph.body?.trim(),
  );
  const visibleFootnotes = disclosureFootnotes.items;

  return (
    <section
      className="cms-section cms-important-disclosures"
      data-cms-module="important-disclosures"
      aria-labelledby="cms-important-disclosures-heading"
    >
      <div className="cms-wrap cms-important-disclosures__layout">
        <header className="cms-important-disclosures__header">
          <span className="cms-important-disclosures__rule" aria-hidden="true" />
          <h2 id="cms-important-disclosures-heading">
            {heading?.trim() || "Important Disclosures"}
          </h2>
        </header>
        <div className="cms-important-disclosures__content">
          {visibleParagraphs.length ? (
            <div className="cms-important-disclosures__intro">
              {visibleParagraphs.map((paragraph, index) => (
                <p key={index}>
                  {renderTextWithLineBreaks(paragraph.body ?? "")}
                </p>
              ))}
            </div>
          ) : null}
          {visibleFootnotes.length ? (
            <ol className="cms-important-disclosures__footnotes">
              {visibleFootnotes.map((footnote) => (
                <li
                  id={footnote.targetId}
                  key={footnote.key}
                  className="cms-important-disclosures__footnote"
                >
                  <span className="cms-important-disclosures__footnote-number">
                    {footnote.number}
                  </span>
                  <div className="cms-important-disclosures__footnote-content">
                    {footnote.label ? (
                      <span className="cms-important-disclosures__footnote-label">
                        {footnote.label.trim()}
                      </span>
                    ) : null}
                    <span className="cms-important-disclosures__footnote-body">
                      {renderTextWithLineBreaks(footnote.body ?? "")}
                    </span>
                  </div>
                </li>
              ))}
            </ol>
          ) : null}
        </div>
      </div>
    </section>
  );
}
